import { Pipe, PipeTransform } from '@angular/core';

// Returns JSON object keys
@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {

  public transform(value): any {
    if (!value) {
      return null;
    }
    return Object.keys(value);
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/pipe/keys.pipe.ts